var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', [_c('el-header', {
    attrs: {
      "height": "auto"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "inline": "inline",
      "label-suffix": ":"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "role"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.role),
      callback: function($$v) {
        _vm.$set(_vm.form, "role", $$v)
      },
      expression: "form.role"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "cityName"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.cityName),
      callback: function($$v) {
        _vm.$set(_vm.form, "cityName", $$v)
      },
      expression: "form.cityName"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search",
      "loading": _vm.searching
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _c('reset-button', {
    attrs: {
      "remoteMethod": _vm.search
    }
  }), _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        _vm.showPermission()
      }
    }
  }, [_vm._v("新增角色")])], 1)], 1)], 1), _c('el-main', [_c('grid', {
    ref: "grid",
    attrs: {
      "remoteMethod": _vm.getTableData
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "roleDescription",
      "label": "角色"
    }
  }), _c('el-table-column', {
    attrs: {
      "formatter": function (row) { return row.cityName.toString(); },
      "label": "城市",
      "show-overflow-tooltip": "show-overflow-tooltip"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "allocate",
      "label": "已分配账号"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "updateTime",
      "label": "更新时间"
    }
  }), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.showPermission(scope.row)
            }
          }
        }, [_vm._v("修改角色")])]
      }
    }])
  })], 1), _c('el-dialog', {
    attrs: {
      "title": "角色信息",
      "width": "30%",
      "visible": _vm.permissionDialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.permissionDialogVisible = $event
      }
    }
  }, [(_vm.permissionDialogVisible) ? _c('permission-tree', {
    attrs: {
      "data": _vm.role
    },
    on: {
      "submit": _vm.permissionSubmit
    }
  }) : _vm._e()], 1)], 1)], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bbcecbf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bbcecbf","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/role.vue
// module id = 4WWz
// module chunks = 1